import { useMutation, useQueryClient } from '@tanstack/react-query';

import { useToasts } from '../../../cdl/Toast/useToasts';
import { updatePort } from '../../../common/api/clients/port.api';
import { queries } from '../../../common/api/queryKeys/queries';
import { translate } from '../../../common/helpers/translate.helper';

export const usePortEdit = () => {
    const { addErrorToast } = useToasts();
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: updatePort,
        onSuccess: (port) => {
            queryClient.invalidateQueries({ queryKey: queries.ports.detail(port.id).queryKey });
            queryClient.invalidateQueries({ queryKey: queries.ports._def });
        },
        onError: () => {
            addErrorToast(translate('port.updatePortErrorToast'));
        },
    });
};
